import { useState } from 'react'

import { useBirdviewQuickActions } from '../useBirdviewQuickActions'
import { useBirdviewRequestQuickActions } from '../useBirdviewRequestQuickActions'

export function useDashboardBirdviewQuickActions() {
  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    setModal(null)
  }

  const {
    activityDoneById,
    handleActivityToggle,
    handleResetActivityDone,
    pendingIds,
  } = useBirdviewQuickActions()

  const {
    assigneeById,
    handleAssign,
    handleResetAssignee,
    pendingIds: pendingRequestIds,
  } = useBirdviewRequestQuickActions({
    onCloseModal: handleCloseModal,
    onSetModal: setModal,
  })

  function handleResetQuickActions(sectionKey) {
    handleResetActivityDone(sectionKey)
    handleResetAssignee(sectionKey)
  }

  return {
    activityDoneById,
    handleActivityToggle,
    handleResetQuickActions,
    modal,
    pendingIds,
    requestActions: {
      assigneeById,
      pendingIds: pendingRequestIds,
      onAssign: handleAssign,
    },
  }
}
